const config = {
  API_URL: process.env.REACT_APP_API_URL || 'https://instapres.com/api', // override for local dev
  SITE_URL: 'https://instapres.com',
  IS_DEV: process.env.NODE_ENV === 'development',

  PLAY_STORE_LINK: 'https://play.google.com/store/apps/details?id=com.presmobile',
  APP_STORE_LINK: 'https://apps.apple.com/us/app/pres-ba/id1588412145',
  // One smart link for the QR code, the mobile-web "Otvori" bar and every
  // "Preuzmi" link (spec part 8). The server sends it to the right store.
  APP_LINK: 'https://instapres.com/app',
  CONTACT_EMAIL: 'info@instapres.com',

  // In-feed ads (spec 5.12). Display 300x250 first; the slot id is the
  // AdSense/Ad Manager unit for that size.
  ADS: {
    ENABLED: process.env.REACT_APP_ADS !== 'off',
    CLIENT: 'ca-pub-1423089575668905',
    FEED_SLOT: process.env.REACT_APP_AD_SLOT || '3695953846',
  },

  FIREBASE: {
    apiKey: 'AIzaSyD1xvKA2uQHk7ePd78rz0hRjqtUvmFpan8',
    authDomain: 'instapres-4c5d8.firebaseapp.com',
    projectId: 'instapres-4c5d8',
    storageBucket: 'instapres-4c5d8.firebasestorage.app',
    messagingSenderId: '730240503765',
    appId: '1:730240503765:web:cc4bf60d64013de2dc375c',
    measurementId: 'G-3HER4KRW8S',
  },
}

export default config
